import { Close as CloseIcon } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';
import {
  closeSnackbar,
  enqueueSnackbar,
  SnackbarKey,
  SnackbarProvider,
} from 'notistack';
import { useEffect, useState } from 'react';

import * as serviceWorkerRegistration from '../../serviceWorkerRegistration';

const serviceWorkerEnabled = process.env.REACT_APP_ENV === 'production';

if (serviceWorkerEnabled) {
  serviceWorkerRegistration.register({
    onSuccess() {
      enqueueSnackbar('Aplikacja gotowa by działać offline', {
        action: (id) => (
          <IconButton
            size="small"
            color="inherit"
            onClick={() => closeSnackbar(id)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        ),
      });
    },
    onUpdate(registration) {
      const handleRefresh = (key: SnackbarKey) => {
        closeSnackbar(key);

        enqueueSnackbar('Aktualizowanie...', {
          persist: true,
        });

        registration.waiting?.postMessage({ type: 'SKIP_WAITING' });

        let refreshed = false;
        const reload = () => {
          if (refreshed) return;
          refreshed = true;
          window.location.reload();
        };

        navigator.serviceWorker.addEventListener('controllerchange', reload, {
          once: true,
        });

        // Safari / iOS fallback
        setTimeout(reload, 8000);
      };

      enqueueSnackbar('Dostępna jest nowa wersja strony', {
        persist: true,
        action: (key) => (
          <Button
            size="small"
            color="inherit"
            onClick={() => handleRefresh(key)}
          >
            Odśwież
          </Button>
        ),
      });
    },
  });
} else {
  serviceWorkerRegistration.unregister();
}

export const AppController = () => {
  if (serviceWorkerEnabled === false) {
    return null;
  }

  const [online, isOnline] = useState(navigator.onLine);
  const [snackbarKey, setSnackbarKey] = useState<SnackbarKey | null>(null);

  const setOnline = () => isOnline(true);
  const setOffline = () => isOnline(false);

  useEffect(() => {
    window.addEventListener('offline', setOffline);
    window.addEventListener('online', setOnline);

    return () => {
      window.removeEventListener('offline', setOffline);
      window.removeEventListener('online', setOnline);
    };
  }, []);

  useEffect(() => {
    if (snackbarKey) {
      closeSnackbar(snackbarKey);
    }

    if (!online) {
      setSnackbarKey(
        enqueueSnackbar('Aplikacja działa w trybie offline', {
          persist: true,
        })
      );
    }
  }, [online]);

  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    />
  );
};

export default AppController;
